import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import InstagramIcon from "@material-ui/icons/Instagram";
import Draggable from "react-draggable";

const InstagramWidget = () => {
  const language = useSelector((state) => state.store.language);
  const enable_instagram_widget = useSelector(
    (state) => state.store.store.settings.enable_instagram_widget
  );
  const link_instagram = useSelector(
    (state) => state.store.store.settings.link_instagram
  );
  const enable_ebutler = useSelector(
    (state) => state.store.store.settings.enable_ebutler_widget
  );
  const ebutler_company_id = useSelector(
    (state) => state.store.store.settings.link_ebutler
  );
  const enable_ebutler_staff = useSelector(
    (state) => state.store.store.settings.enable_ebutler_widget_staff
  );
  const isEbutlerWidgetEnabled =
    enable_ebutler && ebutler_company_id && enable_ebutler_staff;

  const [shouldShow, setShouldShow] = useState(false);
  const [dragging, setDragging] = useState(false);
  useEffect(() => {
    setTimeout(() => {
      setShouldShow(true);
    }, 50);
  }, []);

     const handleLinkClick = () => {
       window.open(link_instagram, "_blank");
     };

    const onDrag = (event) => {
      event.preventDefault();
      if (!dragging) setDragging(true);
    };

    const onStop = (event) => {
      event.preventDefault();
      setDragging(false);
      if (!dragging) {
        handleLinkClick();
      }
    };

  if (!enable_instagram_widget || !link_instagram) return null;

  return shouldShow ? (
    <Draggable axis="y" onDrag={onDrag} onStop={onStop}>
      <div
        className={"instagram-widget-background"}
        style={{
          boxShadow: "rgb(0 0 0 / 15%) 0px 1px 3px 1px ",
          color: "white",
          fontSize: "1.5em",
          height: "60px ",
          margin: "0px ",
          position: "fixed ",
          bottom: "340px",
          zIndex: "1500",
          direction: language === "english" ? "rtl" : "ltr",
          right: language === "english" ? "0px" : "",
          left: language === "english" ? "" : "0px",
          width: "40px",
          borderRadius:
            language === "english" ? "5px 0px 0px 5px" : "0px 5px 5px 0px",
          cursor: "pointer",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <InstagramIcon />
      </div>
    </Draggable>
  ) : null;
};

export default InstagramWidget;
